export default  {
    apps: "/restaurant-apps/",
    qrOrdering: "/qr-ordering/",
    qrMenu: "/qr-menu/",
    onboarding: "/start/",
    pricing: "/pricing/",
    contact: "/contact/",
    app: "/app/"
}